import * as s from "styles/ModalCommonStyled";
import BigButton from "components/atoms/buttons/BigButton";
import * as ac from "../AccountStyled";
import transferIcon from "assets/icons/transfer.svg";
import { PricingRequest } from "api/interfaces/accountInterface.interface";
import StepperComponent from "components/blocks/stepper/Stepper";
import { AddOrgPricing } from "../add/AddOrgPricing";
import { addOrgSteps } from "utils/AccountUtil";
import TransferModal from "../transfer";
import { Account } from "api/mappers/accountMapper";
import { DISCOUNT_TIER } from "api/interfaces/subscription.interface";
import { ValidateMsg } from "api/interfaces/commonInterface.interface";
import { Option } from "utils/options";
import BigPopupTemplate from "components/templates/modal/big/BigPopupTemplate";
import { EditAccountInfo, UPDATE_TYPE } from "../detail/AccountDetailContainer";
import { AccountInner } from "../detail/AccountInner";
import AccountDelete from "../detail/AccountDelete";

interface Props {
  onClickSave: () => void;
  accountInfo: Account;
  editAccountInfo: EditAccountInfo;
  onChangeAccountInfo: (
    type: UPDATE_TYPE,
    value: number | string | boolean
  ) => void;
  logoHandleChange: (e: any) => void;
  logoImage: string;
  isUpdateLoading: boolean;
  isUpdateDisabled: boolean;
  validateMsg: ValidateMsg;
  accountAdmins: Option[];
  enableTransfer?: boolean;
  setValidateMsg: React.Dispatch<React.SetStateAction<ValidateMsg>>;
  onSave: () => void;
  setEditAccountInfo: React.Dispatch<React.SetStateAction<EditAccountInfo>>;
  onModal?: (type?: string) => void;
  isDw: boolean;
  page: number;
  onChangePage: (name: string, index?: number) => void;
  onChangePricing: (
    name: string,
    value: DISCOUNT_TIER | number | undefined
  ) => void;
  isTransferModal: boolean;
  setIsTransferModal: React.Dispatch<React.SetStateAction<boolean>>;
  uploadingLogo: boolean;
}
export default function EditModalPresenter(props: Props): JSX.Element {
  const {
    onClickSave,
    accountInfo,
    editAccountInfo,
    onChangeAccountInfo,
    logoHandleChange,
    logoImage,
    isUpdateLoading,
    isUpdateDisabled,
    validateMsg,
    accountAdmins,
    enableTransfer,
    isDw,
    page,
    onChangePage,
    onModal,
    onChangePricing,
    isTransferModal,
    setIsTransferModal,
    uploadingLogo,
  } = props;
  const isDwPage0 = isDw && page === 0;
  const isDwPage1 = isDw && page === 1;
  return (
    <BigPopupTemplate
      title="Edit Organization"
      onModal={() => onModal?.("edit")}
    >
      <s.AddWrapper>
        {isDw && (
          <StepperComponent
            activeStep={page}
            steps={addOrgSteps}
            onClick={onChangePage}
            data-testid="account-edit-edit-stepper-component-change-page"
          />
        )}

        {page === 0 && (
          <AccountInner
            accountInfo={accountInfo}
            editAccountInfo={editAccountInfo}
            onChangeAccountInfo={onChangeAccountInfo}
            logoHandleChange={logoHandleChange}
            logoImage={logoImage}
            isUpdateLoading={isUpdateLoading}
            validateMsg={validateMsg}
            accountAdmins={accountAdmins}
            uploadingLogo={uploadingLogo}
          />
        )}

        {isDwPage1 && (
          <AddOrgPricing
            pricing={{ ...(editAccountInfo as PricingRequest) }}
            onChangePricing={onChangePricing}
            validateMsg={validateMsg.discount}
            validate={validateMsg.discount !== ""}
          />
        )}
      </s.AddWrapper>
      <ac.EditButtonWrapper>
        <s.ButtonWrapper
          style={{
            width: enableTransfer ? "auto" : "100%",
          }}
        >
          {(isDwPage0 || !isDw) && (
            <AccountDelete
              onModal={onModal}
              accountId={editAccountInfo.accountId}
              accountName={editAccountInfo.name}
              isMyAccount={false}
            />
          )}

          {isDwPage0 && (
            <BigButton
              id="dw_account_button__next"
              label={"Next"}
              delay
              onClickBtn={() => onChangePage("next")}
              disabled={isUpdateDisabled}
              data-testid="account-edit-edit-button-next-change-page"
            />
          )}

          {isDwPage1 && (
            <BigButton
              id="dw_account_button_create"
              label="Previous"
              onClickBtn={() => onChangePage("previous")}
              buttonType="cancel"
              data-testid="account-edit-edit-button-create-change-page"
            />
          )}

          {(isDwPage1 || !isDw) && (
            <BigButton
              id="dw_account_button__save"
              label={"Save"}
              delay
              onClickBtn={onClickSave}
              disabled={isUpdateDisabled}
              data-testid="account-edit-edit-button-save-click-save"
            />
          )}
        </s.ButtonWrapper>

        {enableTransfer && !isDw && (
          <BigButton
            buttonType="cancel"
            label="Transfer Organization"
            iconComponent={<ac.IconTransfer src={transferIcon} alt="" />}
            onClickBtn={() => setIsTransferModal(true)}
            data-testid="account-edit-edit-button-set-is-transfer-modal"
          />
        )}
      </ac.EditButtonWrapper>
      {isTransferModal && (
        <TransferModal
          onModal={() => setIsTransferModal(false)}
          onSuccessTransfer={() => {
            setIsTransferModal(false);
            onModal?.("edit");
          }}
          accountInfo={accountInfo}
        />
      )}
    </BigPopupTemplate>
  );
}
